module.exports = __webpack_public_path__ + "static/media/amex.d8fd7adb.svg";